import * as Yup from 'yup';

// report form model
export const vehicleRecordsReportFormModel = {
  formId: 'vehicleRecordsReportConfig',
  formField: {
    vehicleNumber: {
      name: 'vehicle',
      label: 'Select Vehicle',
      type: 'select',
      data: [{ id: 'all', name: 'All', registration_num: 'All' }]
    },
    startTime: {
      name: 'date__gte',
      label: 'Start Date',
      errorMsg: 'Start date is required!',
      type: 'date'
    },
    endTime: {
      name: 'date__lte',
      label: 'End Date',
      errorMsg: 'End date is required!',
      type: 'date'
    }
  }
};

// Initial values
const {
  formField: {
    vehicleNumber,
    startTime,
    endTime
  }
} = vehicleRecordsReportFormModel;

export const vehicleRecordsReportFormInitialValues = {
  [vehicleNumber.name]: 'all',
  [startTime.name]: '',
  [endTime.name]: '',
};

// validation schema
export const vehicleRecordsReportValidationSchema = Yup.object().shape({
  [startTime.name]: Yup.date().nullable().required(startTime.errorMsg),
  [endTime.name]: Yup.date().nullable().required(endTime.errorMsg)
});

export const vehicleRecordsReportFormConfig = {
  formModel: vehicleRecordsReportFormModel,
  initialValues: vehicleRecordsReportFormInitialValues,
  validation: vehicleRecordsReportValidationSchema,
};
